import { trackEvent } from "src/utils/api/tracker";
import { send } from "src/utils/fetch";
import { getLanguage } from "../meristemContext";
import { createAppAsyncThunk } from "../redux/async-thunk";

const FAST_FORWARD_TRIAL_URL_V2 = "/api/payment/v4/fast_forward_trial/";

export const requestFastForwardTrial = createAppAsyncThunk(
  "fastForwardTrial/request",
  async (
    params: {
      discountOffered: boolean;
      upsellDiscountCode?: string;
    },
    thunkApi
  ) => {
    const { discountOffered, upsellDiscountCode } = params;
    const planDiscountApplied = discountOffered ? "Yes" : "No";
    const { serverContext } = thunkApi.getState();

    const orderId = discountOffered
      ? serverContext.fast_forward_order.uuid
      : serverContext.minimal_discount_fast_forward_order.uuid;

    const request = {
      order_id: orderId,
      language: getLanguage(),
      upsellDiscountCode: upsellDiscountCode ?? undefined,
    };

    const response = await send("POST", FAST_FORWARD_TRIAL_URL_V2, request);
    trackEvent("SkipTrialAccepted", { planDiscountApplied });
    return response;
  }
);
